'use strict';

import React, {useState, useMemo, useCallback, useEffect} from 'react';

import config from '../../shared/config';
import {apiCall} from "../../shared/api-client";
import Toggles, {AsteriskTogglesCl} from "../../react-components/toggles";

import {getFieldName, getFieldTitle} from "./shared";
import {useDashboardFilter, updateFilter} from './state';


function formatFilterValues(values) {
	if (values[0] === '*') {
		return 'All';
	}
	if (values.length > 3) {
		return `${values.slice(0, 3).join(', ')} and ${values.length - 3} more`;
	}
	return values.join(', ');
}

class TogglesCl extends AsteriskTogglesCl {
	formatValues(getter) {
		return formatFilterValues(Array.from(this.toggledOn(getter)));
	}
}

function FilterSelector({field, title, initialValue, options, onChange}) {
	const togglesChangeHandler = useCallback((toggles) => {
		if (onChange instanceof Function) {
			let v = [... toggles.toggledOn()];
			onChange(field, v);
		}
	}, [onChange]);
	const togglesCL = new TogglesCl(options);
	return (
		<div className="cm-filter">
			<div className="cm-label">{title}:</div>
			<div className="cm-values">
				<Toggles options={togglesCL} initialValue={initialValue} onChange={togglesChangeHandler}/>
			</div>
		</div>
	);
}


function Filter() {
	const presetFields = useMemo(() => config.get('Filters'), [config]);
	const [filter, setFilter] = useDashboardFilter();
	const [state, setState] = useState(filter);
	const [presets, setPresets] = useState(null);

	useEffect(() => {
		let canceled = false;
		(async () => {
			let fields = presetFields.map(getFieldName);
			let response = await apiCall({
				method: 'filters/values',
				params: {fields}
			});
			if (!canceled) {
				setPresets(response.fields);
			}
		})();
		return () => {
			canceled = true;
		}
	}, [presetFields]);

	const onChange = useCallback((field, value) => {
		setState(
			f => {
				f = updateFilter(f, {[field]: value});
				return f;
			}
		);
	}, [setState]);

	if (presets === null) {
		return 'Loading filter values';
	}

	const onRefresh = (e) => {
		e.preventDefault();
		console.debug('Setting dashboard filter', state.toJS());
		// We need to reload the dashboard even if the filter didn't actually change.
		setFilter(state.toMap());
	};

	const onReset = (e) => {
		console.debug('Resetting dashboard filter');
		e.preventDefault();
		setFilter(f => f.clear());
	};

	return (
		<section className="filter cm-filters-hash">
			{
				presetFields.map((f) => {
					let field = getFieldName(f);
					let title = getFieldTitle(f);
					let options = presets[field];
					return <FilterSelector
						key={field} field={field} title={title}
						options={options} initialValue={state.get(field)}
						onChange={onChange}
					/>
				})
			}
			<div className="btn-group">
				<button className="btn btn-sm btn-danger" onClick={onReset}>
					<i className="fas fa-undo"/> Reset filter</button>
				<button className="btn btn-sm btn-success" onClick={onRefresh}>
					<i className="fas fa-sync"/> Refresh</button>
			</div>
		</section>
	);
}

export default Filter;